import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { InputText, Spacer } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'

const FIELDS = {
  name: 'name',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('item_category', { scope: 'activerecord.models' }),
})

const AdminItemCategoryNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdItemCategory, flush } = await adminService.createItemCategory(values)
    // TODO 遷移先でのFlush
    location.href = '/admin/item_categories'
  }, [])

  return (
    <AdminLayoutNew
      model="item_category"
      title={title}
      fields={FIELDS}
      indexLink="/admin/item_categories"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label="Name" />
          <Spacer />
          <InputText required={true} name="position" defaultValue="" label="Position" />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminItemCategoryNew
